import AsyncStorage from '@react-native-async-storage/async-storage';

class AsyncStorageHelper {
  // Sauvegarder une valeur de façon sécurisée
  static async setItem(key, value) {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      await AsyncStorage.setItem(key, stringValue);
      return true;
    } catch (error) {
      console.error(`AsyncStorage setItem error for key ${key}:`, error);
      return false;
    }
  }

  // Récupérer une valeur avec parsing sécurisé
  static async getItem(key, defaultValue = null) {
    try {
      const value = await AsyncStorage.getItem(key);
      
      if (value === null || value === undefined) {
        return defaultValue;
      }
      
      // Si c'est déjà un objet, le retourner directement
      if (typeof value === 'object') {
        console.warn(`AsyncStorage key ${key} returned object instead of string`);
        return value;
      }
      
      // Essayer de parser le JSON
      try {
        return JSON.parse(value);
      } catch (parseError) {
        // Si le parsing échoue, retourner la valeur brute
        console.warn(`Failed to parse JSON for key ${key}, returning raw value:`, value);
        return value;
      }
    } catch (error) {
      console.error(`AsyncStorage getItem error for key ${key}:`, error);
      return defaultValue;
    }
  }

  // Récupérer une valeur string simple
  static async getString(key, defaultValue = '') {
    try {
      const value = await AsyncStorage.getItem(key);
      return value || defaultValue;
    } catch (error) {
      console.error(`AsyncStorage getString error for key ${key}:`, error);
      return defaultValue;
    }
  }

  // Récupérer un objet avec validation
  static async getObject(key, defaultValue = {}) {
    try {
      const value = await AsyncStorage.getItem(key);
      
      if (!value) {
        return defaultValue;
      }
      
      // Validation que c'est bien une string
      if (typeof value !== 'string') {
        console.error(`AsyncStorage key ${key} is not a string:`, typeof value, value);
        return defaultValue;
      }
      
      const parsed = JSON.parse(value);
      return parsed || defaultValue;
    } catch (error) {
      console.error(`AsyncStorage getObject error for key ${key}:`, error);
      return defaultValue;
    }
  }

  // Supprimer une clé
  static async removeItem(key) {
    try {
      await AsyncStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(`AsyncStorage removeItem error for key ${key}:`, error);
      return false;
    }
  }

  // Nettoyer toutes les clés avec un préfixe
  static async clearWithPrefix(prefix) {
    try {
      const keys = await AsyncStorage.getAllKeys();
      const keysToRemove = keys.filter(key => key.startsWith(prefix));
      await AsyncStorage.multiRemove(keysToRemove);
      console.log(`Cleared ${keysToRemove.length} keys with prefix ${prefix}`);
      return true;
    } catch (error) {
      console.error(`AsyncStorage clearWithPrefix error:`, error);
      return false;
    }
  }

  // Debug: lister toutes les clés et valeurs
  static async debugStorage() {
    try {
      const keys = await AsyncStorage.getAllKeys();
      console.log('=== AsyncStorage Debug ===');
      
      for (const key of keys) {
        const value = await AsyncStorage.getItem(key);
        console.log(`${key}:`, typeof value, value?.substring(0, 100));
      }
      
      console.log('=========================');
    } catch (error) {
      console.error('AsyncStorage debug error:', error);
    }
  }
}

export default AsyncStorageHelper;